/* eslint-disable no-param-reassign */
/* eslint-disable prefer-exponentiation-operator */
/* eslint-disable no-restricted-properties */
// function for appending k,m,b,t...
export const abbreviateNumber = (prefix, num, decimals = 1) => {
  if (num === null) {
    return null;
  } // terminate early
  if (num === 0) {
    return '0';
  } // terminate early
  decimals = !decimals || decimals < 0 ? 0 : decimals; // number of decimal places to show
  // getting length of number before decimal
  const splittedNumberLength = num.toString().split('.')[0].toString().length;

  if (splittedNumberLength > 3) {
    const b = num.toPrecision(2).split('e'); // get power
    const k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3); // floor at decimals, ceiling at trillions
    const c =
      k < 1
        ? num.toFixed(0 + decimals)
        : (num / Math.pow(10, k * 3)).toFixed(1 + decimals); // divide by power
    const d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
    let formattedNum = 0;
    if (d < 0) {
      formattedNum = `-${prefix}${(-1 * d).toLocaleString()}`;
    } else {
      formattedNum = prefix + d.toLocaleString();
    }
    const e = formattedNum + ['', 'K', 'M', 'B', 'T'][k]; // append power
    return e;
  }

  // adding prefix and negative sign as per num value after taking abs
  return `${num < 0 ? '-' : ''}${prefix}` + Math.abs(num).toFixed(0 + decimals);
};

// Function for formatting numbers as comma separated
export const numberWithCommas = (x, decimals = 0) => {
  const roundedNumber = Number(x.toFixed(0 + decimals));
  const parts = roundedNumber.toString().split('.');
  parts[0] = parts[0].replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const numberWithCommasWithoutDecimal = (x) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
